import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';

export const Navbar = () => {
    
    const auth = useAuth();

    return (
        <nav className="navbar navbar-expand-lg navbar-dark m8-nav">
            <div className="container">
                <Link to="/" className="navbar-brand">
                    <img src="assets/img/mpro-bc.svg" width="30" height="30" class="d-inline-block align-top" alt=""></img>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    {auth.isLogged() && (
                        <div className="navbar-nav">
                            <NavLink exact activeClassName="active" to="/" className="nav-link">Inicio</NavLink>
                            <NavLink exact activeClassName="active" to="/upload" className="nav-link">Subir facturas</NavLink>
                            <NavLink exact activeClassName="active" to="/acuse" className="nav-link">Acuses</NavLink>
                            {auth.user.tabla.toUpperCase()==='PROVEEDOR'?
                                <NavLink activeClassName="active" to="/price" className="nav-link">Cotizaciones</NavLink>
                                :''
                            }
                            <NavLink exact activeClassName="active" to="/" onClick={auth.logout} className="nav-link">Salir</NavLink>
                        </div>
                    )}
                </div>
            </div>
        </nav>
    )
}